import React, { type CSSProperties } from 'react';

import * as linkify from 'linkifyjs';

import shouldNoFollow from 'common/util/shouldNoFollow';

const LinkStyle: CSSProperties = {
  cursor: 'pointer',
  textDecoration: 'underline',
};

const Linkify = ({ children }: { children: string }) => {
  if (typeof children !== 'string') {
    return <>{children}</>;
  }

  const results = linkify.find(children);
  if (results.length === 0) {
    return <>{children}</>;
  }

  const items: React.ReactNode[] = [];
  let position = 0;

  results.forEach((result, index) => {
    const linkStart = children.indexOf(result.value, position);

    const before = children.substring(position, linkStart);
    if (before.length > 0) {
      items.push(before);
    }

    items.push(
      <a
        key={index}
        href={result.href}
        target="_blank"
        rel={`noopener noreferrer ${shouldNoFollow(result.href) ? 'nofollow' : ''}`}
        style={LinkStyle}>
        {result.value}
      </a>,
    );

    position = linkStart + result.value.length;
  });

  const after = children.substring(position, children.length);
  if (after.length > 0) {
    items.push(after);
  }

  return <>{items}</>;
};

export default Linkify;
